import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/system';
import theme from '../../theme';
import AddCardIcon from '@mui/icons-material/AddCard';

/** MUI fixed AppBar ~64px; theme spacing 12 = 96px with default 8px step */
export const S: { [key: string]: any } = {
    rootContainer: {
        paddingTop: {
            xs: 12,
            sm: 12,
            md: 12,
            lg: 12
        },
        paddingLeft: {
            xs: 2,
            sm: 2,
            md: 13,
            lg: 13
        },
        paddingRight: {
            xs: 2,
            sm: 2,
            md: 15,
            lg: 15
        }
    },
    pageTitle: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '28px',
        lineHeight: '34px',
        color: theme.color.white90
    },
    sectionTitle: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '20px',
        lineHeight: '26px',
        color: theme.color.white90,
        marginBottom: 0
    }
};

export const Root = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 30,
    height: 'fit-content',
    paddingBottom: 50
});

/** Base body typography for Billing; titles/buttons/empty states set their own sizes. */
export const BillingContentRoot = styled(Box)({
    fontFamily: 'Inter, sans-serif',
    fontSize: '14px',
    lineHeight: 1.57,
    '& .MuiTableCell-root': {
        fontSize: 'inherit',
        fontFamily: 'inherit'
    },
    '& .MuiTablePagination-root': {
        fontSize: '14px',
        fontFamily: 'Inter',
        fontWeight: 500,
        lineHeight: '12px',
        textAlign: 'center',
        color: theme.color.white50,
        paddingTop: '10px',
        paddingBottom: '10px',
        display: 'block'
    },
    '& .MuiTablePagination-toolbar': {
        fontSize: 'inherit',
        minHeight: 52
    },
    '& .MuiTablePagination-selectLabel': {
        fontSize: 'inherit'
    },
    '& .MuiTablePagination-displayedRows': {
        fontSize: 'inherit'
    },
    '& .MuiTablePagination-root .MuiInputBase-root': {
        fontSize: 'inherit'
    }
});

export const PageHeader = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
});

export const SectionHeader = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 16,
    marginBottom: 20
});

export const InvoicesLoadingContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 64,
    paddingBottom: 64
});

export const InvoicesLoadingSpinner = styled(CircularProgress)({
    color: theme.color.lightningYellowRgba
});

export const SelectProjectEmptyState = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 48,
    paddingBottom: 48,
    color: theme.color.white50,
    fontFamily: 'Inter',
    fontSize: '16px',
    lineHeight: 1.5
});

export const AddPaymentButton = styled(Button)({
    borderRadius: 16,
    border: '1px solid rgba(255, 220, 168, 0.35)',
    color: theme.color.lightningYellow,
    backgroundColor: 'rgba(255, 220, 168, 0.1)',
    textTransform: 'none',
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
    fontWeight: 500,
    lineHeight: '20px',
    padding: '10px 18px',
    minHeight: 44,
    boxSizing: 'border-box',
    '& .MuiButton-endIcon': {
        marginLeft: 12,
        marginRight: 0,
        display: 'inline-flex'
    },
    '&:hover': {
        borderColor: 'rgba(255, 220, 168, 0.55)',
        backgroundColor: 'rgba(255, 220, 168, 0.16)'
    },
    '&:disabled': {
        opacity: 0.45,
        color: theme.color.lightningYellow,
        borderColor: 'rgba(255, 255, 255, 0.12)'
    }
});

export const StyledAddCardIcon = styled(AddCardIcon)({
    width: 20,
    height: 20,
    fill: theme.color.lightningYellow,
    flexShrink: 0
});
